import cookie from 'js-cookie'

// Recette du test A/B des recommandations (dev et staging) : le bandeau d'environnement force
// le bras A (temoin) ou B (nouveau moteur) pour ce navigateur. Le proxy CS-Cart transmet le choix
// en en-tete X-Pharme-Reco-Variant ; la boutique ne l'ecoute que si sa configuration l'autorise
// (recommend.allow_variant_override), jamais en production.

export const RECO_VARIANT_COOKIE = 'pharme_reco_variant'
export const RECO_VARIANT_HEADER = 'X-Pharme-Reco-Variant'

export type RecoVariantOverride = 'A' | 'B'

export const isRecoVariantOverride = (value: unknown): value is RecoVariantOverride =>
  value === 'A' || value === 'B'

export const readRecoVariantOverride = (): RecoVariantOverride | null => {
  const value = cookie.get(RECO_VARIANT_COOKIE)
  return isRecoVariantOverride(value) ? value : null
}

/** null = bras naturel du compte (repartition par user_id) */
export const writeRecoVariantOverride = (value: RecoVariantOverride | null): void => {
  if (value) {
    cookie.set(RECO_VARIANT_COOKIE, value, { expires: 30, sameSite: 'lax' })
  } else {
    cookie.remove(RECO_VARIANT_COOKIE)
  }
}
